var _defs, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    width: 10.498,
    height: 13.177,
    viewBox: "0 0 10.498 13.177",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M23.455,6.4A5.267,5.267,0,0,0,18.2,11.666a5.34,5.34,0,0,0,.1,1.044c0,.023.011.045.011.079.579,2.6,4.653,6.5,4.823,6.662a.436.436,0,0,0,.318.125.488.488,0,0,0,.318-.125c.17-.17,4.222-4.063,4.8-6.605,0-.023.011-.045.011-.068A5.289,5.289,0,0,0,23.455,6.4Zm4.222,6.208v.034c-.431,1.884-3.257,4.858-4.222,5.822-.965-.965-3.8-3.938-4.233-5.868a.1.1,0,0,0-.011-.057,4.687,4.687,0,0,1-.091-.885,4.33,4.33,0,1,1,8.557.953Z",
    transform: "translate(-18.2 -6.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M50.759,32.5a1.759,1.759,0,1,0,1.759,1.759A1.761,1.761,0,0,0,50.759,32.5Zm0,2.6a.84.84,0,1,1,.84-.84A.838.838,0,0,1,50.759,35.1Z",
    transform: "translate(-45.504 -29.538)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.cfc8852d.svg";
export { ForwardRef as ReactComponent };